// v2 room mapping fetch. Uses the same plain-axios + cookie-header path as v1
// (src/lib/apis/room.ts) rather than the shared axiosInstance, so the request
// is authenticated identically to the working v1 column view. Returns the
// rooms a doctor's mapping is assigned to: one room → a doctor-level badge,
// more than one → per-patient room tags.
import axios from "axios";
import { baseURL } from "../../lib/utils/constants";
import { header } from "../../lib/utils/header";

export interface RoomMapping {
  room_id: string;
  room_name: string;
}

export const getRoomMapping = async (
  mappingId: string
): Promise<RoomMapping[]> => {
  const res = await axios.get(
    `${baseURL}/queue/room/mapping/${mappingId}`,
    { headers: header() }
  );
  const list = res?.data?.result ?? [];
  return Array.isArray(list) ? list : [];
};
